module.exports = __webpack_public_path__ + "img/banner_dummy_swim.246462e3.png";